export default __webpack_public_path__ + "static/media/misc-books2-2048w.ae0d5bf2.avif";